var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"search","d":"M18.146,16.87l-3.4-3.4a6.322,6.322,0,1,0-1.276,1.276l3.4,3.4a.9.9,0,0,0,1.276-1.276ZM5.179,9.69A4.511,4.511,0,1,1,9.69,14.2,4.511,4.511,0,0,1,5.179,9.69Z","transform":"translate(-3.375 -3.375)"}));
}

Search.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 15 15","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Search;

Search.default = Search;
